document.addEventListener('DOMContentLoaded', function() {
  
  const gridItems = document.querySelectorAll('.koji-cat-item');
  if (!gridItems.length) return;

  // Configurazione Observer per l'animazione di entrata a cascata (App-like feel)
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -40px 0px', // Triggera la comparsa leggermente prima che l'elemento entri pienamente dal basso
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Aggiunge la classe che aziona l'animazione nel CSS
        entry.target.classList.add('is-visible');
        // Ferma l'osservazione una volta che la card è apparsa
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Applica lo staggered delay a ogni card per un effetto "a onda" fluido
  gridItems.forEach((item, index) => {
    // Limitiamo il ritardo per evitare che le ultime righe ci mettano troppo a comparire
    const delay = (index % 3) * 0.08; 
    
    item.style.transition = `opacity 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${delay}s, 
                             transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${delay}s`;
    
    observer.observe(item);
  });

});